import { ErrorFallback } from 'ComponentLibrary'
import { ComponentType } from 'react'
import { ErrorBoundary as ReactErrorBoundary, ErrorBoundaryPropsWithComponent, FallbackProps } from 'react-error-boundary'

type ErrorBoundaryProps = Omit<ErrorBoundaryPropsWithComponent, 'FallbackComponent'> & {
    children: React.ReactNode
    CustomErrorFallback?: ComponentType<FallbackProps>
}

export default function ErrorBoundary({ children, CustomErrorFallback, ...rest }: ErrorBoundaryProps) {
    return (
        <ReactErrorBoundary {...rest} FallbackComponent={CustomErrorFallback ? CustomErrorFallback : ErrorFallback}>
            {children}
        </ReactErrorBoundary>
    )
}
